import { render, staticRenderFns } from "./GiftPurchases.vue?vue&type=template&id=2c8a6d92&scoped=true&"
import script from "./GiftPurchases.vue?vue&type=script&lang=ts&"
export * from "./GiftPurchases.vue?vue&type=script&lang=ts&"
import style0 from "./GiftPurchases.vue?vue&type=style&index=0&id=2c8a6d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8a6d92",
  null
  
)

export default component.exports